module.exports = __webpack_public_path__ + "img/birthday.e9a673df.jpg";